import { UXAContextClient } from '@contentsquare/uxanalytics-client';
import { ClientFactory } from './app.client.factory';
import { AppContextFactory } from './app.context.factory';
export class UxaContextStorageService {
    constructor(uxaContextClient, appContext) {
        this.uxaContextClient = uxaContextClient;
        this.appContext = appContext;
    }
    static get() {
        if (!UxaContextStorageService.instance) {
            UxaContextStorageService.instance = new UxaContextStorageService(ClientFactory.get(UXAContextClient), AppContextFactory.get());
        }
        return UxaContextStorageService.instance;
    }
    async getContext(hash) {
        if (hash) {
            const currentContext = await this.uxaContextClient.get(this.appContext.projectId, hash);
            return currentContext;
        }
        return {};
    }
    async saveContext(context) {
        const hash = await this.uxaContextClient.save(this.appContext.projectId, context);
        return hash;
    }
}
//# sourceMappingURL=uxa-context-storage.service.js.map